<template>
    <div class="home-box">
      <PageTitle :title="pageTitle" class="py-5"></PageTitle>
      <v-row align="center">
        <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
        </v-overlay>
  
        <div class="col-md-12 home-tabs-body">
          <RequisitionCreateForm v-if="mode==='create' || productsArray.length > 0" :formData="formData" :mode="mode" :id="id" :proploading="loading" :productsArray="productsArray"></RequisitionCreateForm>
        </div>
      </v-row>
    </div>
</template>
  
  <script>
  import RequisitionCreateForm from "@/components/Requisition/RequisitionCreateForm";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  import { RequisitionService } from "@/services/requisition-service.js";
  
  export default {
    name: "CreateRequisition",
    components: {
      PageTitle,
      RequisitionCreateForm
    },
    props: {
      mode: { type: String, required: true },
      id: { type: String, default: null },
    },
    data: function () {
      return {
        role: localStorage.getItem('role') || null,
        errors : null,
        loading : false,
        formData: {
          branch_id: "",
          items: [],
          comment: "",
          expected_delivery_date: "",
        },
        productsArray: [],
  
      };
    },
    computed: {
      ...mapGetters({
        vuexloading: "loading",
        profile: "profile",
        hasPermission: "hasPermission",
      }),
      pageTitle() {
        return this.mode === "edit" ? "Update Requisition" : "Create Requisition";
      },
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
      this.$store.dispatch("settings/getCompanySettings");
      if (this.mode === "edit") {
        this.fetchRequisition();
      }
    },
  
    methods: {
      async fetchRequisition() {
        if(!this.id) return;
        try {
          this.loading = true;
          const response = await RequisitionService.getRequisitionDetails(this.id);
          const Requisition = response.data;
          this.formData.branch_id = Requisition.branch_id;
          this.formData.items = Requisition.items;
          this.formData.expected_delivery_date = Requisition.expected_delivery_date;
          this.formData.comment = Requisition.comment;
          this.formData.status = Requisition.status;
          this.productsArray = [...Requisition.productsarray];
        } catch (error) {
          console.error(error);
          this.errors = error.message;
        } finally{
          this.loading = false;
        }
      }
    },
  
    watch: {
    }
  };
  </script>
  